import { Box, Breadcrumbs } from '@mui/material'
import I18n from 'i18n-js'
import React, { useCallback, useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { Link } from 'react-router-dom'
import Associate from '../../../components/associate'
import BtnBN from '../../../components/btnBN'
import ViewFinally from '../../../components/finallyView/finally'
import Loading from '../../../components/loading'
import { listGroup } from '../../../service/group'
import { user } from '../../../service/user'
import LinkStyles from '../../../themes/js/Link'
import useStyles from './styles'

const UserAssociate = () => {
  const history = useHistory()
  const classes = useStyles()
  const [listSurvey, setListSurvey] = useState()
  const [associateData, setAssociateDaata] = useState()
  const [isLoadind, setIsLoading] = useState(true)
  const { id } = useParams()
  const [sentSuccessfully, setSentSuccessfully] = useState(false)

  const getData = useCallback(async () => {
    const res = await listGroup()

    const detail = await user.getUserGroups(id)

    if (detail.data !== null) {
      const listSurveys = detail.data.user_groups?.map((item) => item?.id) ?? []

      setAssociateDaata({
        indicators: listSurveys,
      })
    }

    const data = res?.data?.groups?.map((item) => ({
      ...item,
      name: item?.name,
    }))
    setListSurvey(data || [])
    setIsLoading(false)
  }, [id])

  const handleStep = async (_) => {
    const body = {
      groups: associateData?.indicators ?? [],
    }

    const res = await user.addUserGroups(id, body)

    if (res?.data !== null) {
      setSentSuccessfully(true)
    }
  }

  useEffect(() => {
    getData()
  }, [getData])

  if (isLoadind) return <Loading />

  return (
    <Box className={classes.container}>
      <Box className={classes.header}>
        <Breadcrumbs className={classes.link} aria-label="breadcrumb">
          <Link style={LinkStyles} to="/dashboard">
            {I18n.t('drawer.dashboard')}
          </Link>

          <Link style={LinkStyles} to={`/dashboard/pollsters`}>
            {I18n.t('drawer.users.primary')}
          </Link>

          <Link style={LinkStyles} to={history.location.pathname}>
            {I18n.t('drawer.users.associate')}
          </Link>
        </Breadcrumbs>
      </Box>

      {listSurvey?.length >= 0 && !sentSuccessfully ? (
        <>
          <Box className={classes.associate}>
            <Associate values={associateData} setCreateProfil={setAssociateDaata} dataIndicators={listSurvey} title={I18n.t('exclusionConditions.associate.indicatorsTitle')} />
          </Box>

          <Box className={classes.btns}>
            <BtnBN back={'/dashboard/pollsters'} handleStep={handleStep} />
          </Box>
        </>
      ) : (
        <ViewFinally title={I18n.t('exclusionConditions.finally.title')} subtitle={I18n.t('users.finally.associate')} to="/dashboard/questionlist" btn={I18n.t('users.finally.return')} />
      )}
    </Box>
  )
}

export default UserAssociate
